import { Injectable } from '@angular/core';
import { fillArr, uniqueId } from '@pin-up-global/common';
import { ApiService, ListResponse } from '@shared/abstraction';
import { manageLoadingStatus } from '@shared/rxjs-operators';
import { delay, Observable, of } from 'rxjs';
import {
  BotSticker,
  CreateStickerReq,
  GetBotStickersReq,
  RemoveStickerReq,
  UpdateStickerReq,
} from './stickers-settings.abstraction';

@Injectable()
export class StickersSettingsApiServiceMock extends ApiService {
  isLoading$ = this._isLoading$;

  getBotStickers(params: GetBotStickersReq): Observable<ListResponse<BotSticker>> {
    return of({
          count: 10,
          items: fillArr(10, (i) => ({
            id: i,
            botId: params.botId,
            platformId: `file_id_${ i }`,
            name: `Sticker ${ i }`,
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString(),
          })),
        },
    ).pipe(
        delay(1000),
        manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$),
    );
  }

  createSticker(body: CreateStickerReq): Observable<BotSticker> {
    return of({
      id: uniqueId(),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      ...body,
    }).pipe(
        delay(1000),
        manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$),
    );
  }

  updateSticker(params: UpdateStickerReq): Observable<BotSticker> {
    return of({
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      botId: 1,
      ...params,
    }).pipe(
        delay(1000),
        manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$),
    );
  }

  removeSticker(params: RemoveStickerReq): Observable<null> {
    return of(null).pipe(
        delay(1000),
        manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$),
    );
  }
}
